import { css } from "styled-components";

const theme = {
  font: {
    default: `"Roboto Condensed", sans-serif`
  },
  color: {
    border: `#95a9b6`,
    text: `#135d80`,
    main: `#aabecb`,
    light: `#e0e7ec`,
    dark: `#135d80`,
    accent: `#23a9de`,
    positive: `#008640`,
    negative: `#ff0000`,
    shadow: `rgba(0,0,0,.25)`
  },
  containerWidth: "1280px",
  media: {
    desktop: "(min-width: 1025px)",
    tablet: "(min-width: 769px) and (max-width: 1024px)",
    mobile: "(max-width: 768px)"
  }
};

export const atmedia = Object.keys(theme.media).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media ${theme.media[label]} {
      ${css(...args)};
    }
  `;

  return acc;
}, {});

export default theme;
